// Config picker dialog
//components/configuration/standard/Picker.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
//import Avatar from '@material-ui/core/Avatar';
//import List from '@material-ui/core/List';
//import ListItem from '@material-ui/core/ListItem';
//import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
//import Button from '@material-ui/core/Button';
//import Option from './View';
//import box
//import PersonIcon from '@material-ui/icons/Person';
//import AddIcon from '@material-ui/icons/Add';
//import Typography from '@material-ui/core/Typography';
//import { blue } from '@material-ui/core/colors';

const useStyles = makeStyles({
	//add the other stuf
  	configSelectName : {
		textAlign: 'left',
		fontWeight: 'bold',
		fontSize: '1.1em',
	},
	configSelectDescription: {
		textAlign: 'left',
		fontWeight: 'normal',
		fontSize: '0.9em',
	},
	configSelectBox : {
		flexGrow: 1,
	}
});

export default function OptionPicker(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open, items } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleClickOption = (value) => {
    onClose(value);
  };

	return (
		<Dialog onClose={handleClose} aria-labelledby="option-picker" open={open}>
			<DialogTitle variant="contained" color="primary" id="config-picker">Select a Configuration</DialogTitle>
			<Box>
				{items.map((item, i) => (
				<Button key={i} onClick={(e) => handleClickOption(item)} color={item.owner === 'common' ? 'primary' : 'default'} variant={item.owner === 'common' ? 'contained' : 'outlined'} fullWidth>
					<Box className={classes.configSelectBox}>
					<Typography className={classes.configSelectName}>{item.name}</Typography>
					<Typography className={classes.configSelectDescription}>{item.description}</Typography>
					</Box>
				</Button>
				))}
      		</Box>
    	</Dialog>
	);
}

/*
SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
};

export default function SimpleDialogDemo() {
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <div>
      <Typography variant="subtitle1">Selected: {selectedValue}</Typography>
      <br />
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open simple dialog
      </Button>
      <SimpleDialog selectedValue={selectedValue} open={open} onClose={handleClose} />
    </div>
  );
}
*/
